import I18n from "common/i18n";
import { btnDelay, usePlaySound } from "common/utils";
import { PieceLayoutMode } from "features/builder/pieceList";

// 一覧グリッド先頭に置くチュートリアル導線カード。AddMapCard と同構造で、配色のみ青系。
export const BuilderTutorialCard = ({
  layoutMode,
  onClick,
}: {
  layoutMode: PieceLayoutMode;
  onClick: () => void;
}) => {
  const play = usePlaySound();

  const handleClick = () => {
    play();
    btnDelay(() => onClick());
  };

  if (layoutMode === PieceLayoutMode.LIST) {
    return (
      <div
        onClick={handleClick}
        aria-label={I18n.t("MSG_BUILDER_TOP_GUIDE_BTN")}
        className="flex-row-el flex-center box-border w-full gap-2 py-6 rounded-xl border-2 border-dashed border-blue-100 bg-white/40 pointer-events-auto cursor-pointer"
      >
        <span className="material-symbols-outlined text-blue-100 type-md">menu_book</span>
        <p className="type-text type-body text-blue-100">{I18n.t("MSG_BUILDER_TOP_GUIDE_BTN")}</p>
      </div>
    );
  }

  // GRID_2 は MapCard の compact（aspect-square）、GRID_1 は aspect-[4/3] に合わせる
  const compact = layoutMode === PieceLayoutMode.GRID_2;

  return (
    <div
      onClick={handleClick}
      aria-label={I18n.t("MSG_BUILDER_TOP_GUIDE_BTN")}
      className={`flex-col-el flex-center box-border relative w-full ${
        compact ? "aspect-square" : "aspect-[4/3]"
      } gap-2 rounded-2xl border-2 border-dashed border-blue-100 bg-white/40 pointer-events-auto cursor-pointer`}
    >
      <span className="material-symbols-outlined text-blue-100 type-hero">menu_book</span>
      <p className="type-text type-body text-blue-100">{I18n.t("MSG_BUILDER_TOP_GUIDE_BTN")}</p>
    </div>
  );
};
